import { helper } from '@ember/component/helper';

export default helper(function thumbLetter([word] /*, named*/) {
  if (typeof word === 'string' && word.length > 0) {
    return word.charAt(0).toLowerCase();
  }

  return '';
});
